import { getModules } from '@/actions/data-fetch-modules';
import { ModulesClientWrapper } from './ModulesClientWrapper';


export default async function ModulePage() {

    const response = await getModules({
        page: 1
    })



    return (
        <div>

            <ModulesClientWrapper
                initialData={response.data.modules}
                pagination={response.data.pagination}



            />


        </div>
    );
}

